export default "__VITE_ASSET__BPqPaQ9B__"